export default "__VITE_ASSET__CTwOG4pj__"